"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsV5Client = void 0;
const sdk = __importStar(require("@journeyapps-platform/sdk-common"));
const types_accounts_hub_1 = require("@journeyapps-platform/types-accounts-hub");
class AccountsV5Client extends sdk.SDKClient {
    constructor() {
        super(...arguments);
        this.downgradeAppToTrial = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DOWNGRADE_APP_TO_TRIAL
        });
        this.upgradeAppFromTrial = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPGRADE_APP_FROM_TRIAL
        });
        this.extendAppTrial = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.EXTEND_TRIAL
        });
        this.createUser = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.CREATE_USER
        });
        this.createOrg = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.CREATE_ORG
        });
        /**
         * @deprecated
         */
        this.giveUserAccess = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GIVE_USER_ACCESS
        });
        this.deleteUser = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DELETE_USER
        });
        this.getOrg = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_ORG
        });
        this.getApp = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_APP
        });
        this.getUser = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_USER
        });
        this.listApps = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.LIST_APPS
        }));
        this.listOrgs = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.LIST_ORGS
        }));
        this.listUsers = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.LIST_USERS
        }));
        this.searchOrgs = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.SEARCH_ORGS
        }));
        this.searchApps = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.SEARCH_APPS
        }));
        this.searchUsers = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.SEARCH_USERS
        }));
        // === MUTATION ===
        this.createApp = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.CREATE_APP
        });
        this.deleteApp = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DELETE_APP
        });
        this.updateOrg = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_ORG
        });
        this.updateOrgBilling = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_ORG_BILLING
        });
        this.updateApp = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_APP
        });
        this.updateUser = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_USER
        });
        this.updateOrgLocks = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_ORG_LOCKS
        });
        this.updateAppLocks = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_APP_LOCKS
        });
        // === SIGNUP ===
        this.startSignup = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.START_SIGNUP
        });
        this.getSignupUser = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_SIGNUP_USER
        });
        this.completeSignup = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.COMPLETE_SIGNUP
        });
        this.provisionUserToken = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.PROVISION_USER_TOKEN
        });
        // === DEVELOPER INVITES ===
        this.getUserInvites = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_USER_INVITES
        }));
        this.listDeveloperInvites = sdk.createPaginatedEndpoint(this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.LIST_DEV_INVITES
        }));
        this.createInvite = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.CREATE_DEV_INVITE
        });
        this.updateInvite = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.UPDATE_INVITE
        });
        this.destroyInvite = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DESTROY_INVITE
        });
        this.acceptInvite = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.ACCEPT_INVITE
        });
        this.declineInvite = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.DECLINE_INVITE
        });
        // === Security and MFA ===
        /**
         * Get token for use with SensitiveProfileAccountsV5Client.
         * Currently, this allows for managing MFA configurations.
         */
        this.getSensitiveAccessToken = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_SENSITIVE_ACCESS_TOKEN
        });
        this.listMFAFactors = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.LIST_MFA_FACTORS
        });
        this.getUserPreferredMFAFactor = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.GET_PREFERRED_FACTOR
        });
        this.sendMFASMS = this.createEndpoint({
            path: types_accounts_hub_1.ROUTES.SEND_MFA_SMS
        });
    }
}
exports.AccountsV5Client = AccountsV5Client;
